import {useEffect, useState} from 'react'
import {useLocation} from "react-router-dom";
import useScreenFlow from "./useScreenFlow";

let lastLocation: string | null = null;

/**
 * For some unknown reason when using useScreenFlow -> navigateForward it's getting the older version of a complaint.
 * This is a "fix" for the issue, as we need something fast that doesn't include a whole refactor. Please really fix
 * this functionality at a future date and remove this.
 */
const useTheHackiestPageNavigation = () => {
    const [goToNextStep, setGoToNextStep] = useState(false)
    const location = useLocation()
    const {navigateForward} = useScreenFlow()

    useEffect(() => {
        if (lastLocation === location.pathname) return
        
        lastLocation = location.pathname
        setGoToNextStep(false)
    }, [location.pathname]);

    useEffect(() => {
        if (!goToNextStep) return
        
        navigateForward()
    }, [goToNextStep, navigateForward]);
    
    return {
        navigateForward: () => setGoToNextStep(true)
    }
}

export default useTheHackiestPageNavigation
